import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';

import App from './app';
import * as serviceWorker from './serviceWorker';

if (process.env.REACT_APP_TITLE) {
  document.title = process.env.REACT_APP_TITLE;
}

const container = document.getElementById('root');

const root = ReactDOM.createRoot(container as HTMLElement);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

serviceWorker.unregister();
